import type { AvatarType, FileValidationOptions, ValidationResult } from './types.ts'

export const DEFAULT_VALIDATION: FileValidationOptions = {
	allowedTypes: ['image/png', 'image/jpeg', 'image/webp'],
	maxBytes: 5 * 1024 * 1024 // 5 MB
}

export const readFileAsDataURL = (file: File): Promise<string> => {
	return new Promise((resolve, reject) => {
		const readFile = new FileReader()

		readFile.onerror = () => reject(new Error('read-error'))
		readFile.onload = () => resolve(String(readFile.result))
		readFile.readAsDataURL(file)
	})
}

export const validateFile = (
	file: File | null | undefined,
	opts: FileValidationOptions = DEFAULT_VALIDATION
): ValidationResult => {
	if (!file) {
		return { ok: false, reason: 'no-file' }
	}

	const { allowedTypes = [], maxBytes = Infinity } = opts

	if (allowedTypes.length && !allowedTypes.includes(file.type)) {
		return { ok: false, reason: 'type' }
	}

	if (file.size > maxBytes) {
		return { ok: false, reason: 'size' }
	}

	return { ok: true }
}
